import { useGetListingQuery } from "../../../../components/src/services/listings.service";
import { useGetSpaceQuery } from "../../../../components/src/services/spaces.service";

type UseListingRulesDataArgs = {
  listingId: string;
};

/**
 * SpacesAPI has no endpoint keyed by listing id (every space route is keyed
 * by `:spaceId`), so the parent space is fetched in a second step once the
 * listing tells us its `parentSpaceId`.
 */
const useListingRulesData = ({ listingId }: UseListingRulesDataArgs) => {
  const { data: listing, isFetching: isListingFetching } = useGetListingQuery({
    listingId,
  });

  const parentSpaceId = listing?.parentSpaceId;

  const { data: space, isFetching: isSpaceFetching } = useGetSpaceQuery(
    { spaceId: parentSpaceId ?? "" },
    { skip: !parentSpaceId },
  );

  return {
    listing,
    space,
    isFetching: isListingFetching || isSpaceFetching,
  };
};

export { useListingRulesData };
